<dx-popup
  [visible]="visible()"
  (visibleChange)="visible.set($event)"
  [width]="'60%'"
  [height]="'auto'"
  [maxHeight]="'85vh'"
  [resizeEnabled]="true"
  [showCloseButton]="false">

  <div *dxTemplate="let _ of 'title'" class="dialog-header">
    <div class="dialog-title">
      <yo-icon icon="fa-pencil-alt"></yo-icon>
      <strong>Modifier les taux de prise prévisionnels</strong>
    </div>
    <div class="dialog-actions">
      <yo-button
        iconClass="fas fa-save"
        tooltip="Appliquer"
        [theme]="ButtonThemeEnum.SAVE"
        (onClick)="save()">
      </yo-button>
      <yo-button
        iconClass="fas fa-times"
        tooltip="Fermer"
        [theme]="ButtonThemeEnum.CANCEL"
        (onClick)="closeDialog()">
      </yo-button>
    </div>
  </div>

  <section class="dialog-content">
    <div class="dialog-column">
      <span class="dialog-section-title">
        <strong>Jours ouvrés</strong>
      </span>
      <div class="dialog-section-body">
        <yo-tree-list
          #treeListJours
          [data]="joursSemaine()"
          [returnData]="true"
          key="value"
          displayValue="viewValue"
          mode="list"
          (onValueChange)="onChangeJoursSemaine($event)">
        </yo-tree-list>
      </div>
    </div>

    <div class="dialog-column">
      <span class="dialog-section-title">
        <strong>Repas</strong>
      </span>
      <div class="dialog-section-body">
        <yo-tree-list
          #treeListRepas
          [data]="repasList()"
          [returnData]="true"
          key="id"
          displayValue="libelle"
          childValue="children"
          mode="groupedList"
          (onValueChange)="onChangeRepas($event)">
        </yo-tree-list>
      </div>
    </div>

    <div class="dialog-column">
      <span class="dialog-section-title">
        <strong>Composantes</strong>
      </span>
      <div class="dialog-section-body">
        <yo-tree-list
          #treeListDecoupageRepas
          [data]="decoupageRepasList()"
          [returnData]="true"
          key="id"
          displayValue="libelle"
          childValue="children"
          mode="groupedList"
          (onValueChange)="onChangeDecoupageRepas($event)">
        </yo-tree-list>
      </div>
    </div>

    <div class="dialog-column">
      <span class="dialog-section-title">
        <strong>Plats</strong>
      </span>
      <div class="dialog-section-body">
        <yo-tree-list
          #treeListPlat
          [data]="platList()"
          [returnData]="false"
          key="value"
          displayValue="label"
          mode="list"
          (onValueChange)="onChangePlat($event)">
        </yo-tree-list>
      </div>
    </div>

    <div class="dialog-column">
      <span class="dialog-section-title">
        <strong>Taux de prise prévisionnel</strong>
      </span>
      <div class="dialog-section-body">
        <div class="dialog-input-row">
          <dx-number-box
            [value]="inputValue()"
            (valueChange)="inputValue.set($event)"
            [showSpinButtons]="true"
            width="100%">
          </dx-number-box>
          <span class="dialog-unit">%</span>
        </div>
      </div>
    </div>
  </section>
</dx-popup>
